import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-detail-navbar',
  templateUrl: './product-detail-navbar.component.html',
  styleUrls: ['./product-detail-navbar.component.scss']
})
export class ProductDetailNavbarComponent implements OnInit {
  women: boolean = true;
  men: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
